import { selectors as coreSelectors } from '$data/core';
import { STUDENT } from '$variables/constants';

const selectParticipantsBranch = (state) => state.participants;

const getParticipantsInCurrentSpace = (state) => {
  const spaceId = coreSelectors.getCurrentSpace(state).id;
  const participantsInSpace = selectParticipantsBranch(state)[spaceId];
  return participantsInSpace || {};
};

export const getStudents = (state) => {
  const { participants } = getParticipantsInCurrentSpace(state);
  if (!Array.isArray(participants)) return undefined;
  // eslint-disable-next-line consistent-return
  return participants.filter(({ role }) => role === STUDENT);
};

export const hasStudents = (state) => {
  const students = getStudents(state);
  return Array.isArray(students);
};

export const getStudentInfo = (state, studentId) => {
  const students = getStudents(state);
  return (students || []).find(({ id }) => id === studentId);
};

export const getIsFetchingParticipants = (state) =>
  getParticipantsInCurrentSpace(state).isLoading;
export const getFetchParticipantsError = (state) =>
  getParticipantsInCurrentSpace(state).error;
